module.exports = __webpack_public_path__ + "img/icon_contact_01.ff7cc833.png";